import React, { useState, useRef, useEffect } from "react";
import { CSpinner } from "@coreui/react";
import axios from "axios";
import io from "socket.io-client";
import moment from "moment";
import InternetError from "../../InternetError-component/useOnlineStatus ";
import {
  AvcUrl,
  BaseUrl,
  SocketUrl,
  errorApi,
} from "../../../container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import {
  setcontactlist,
  setcontactlist1,
  setcontactlist2,
  setrefreshtogglechat,
  setconfchatrefresh,
  setAgentList,
  setinternalchatrefresh,
  setchatdata,
  setchatid,
  setselectedmobile,
  setselectedemail,
  setselectedusername,
  setchattype,
  setinternalchatnotify,
  setchatdataforinternal,
  setConferenceNotification,
  setavailagent,
  setloadmore,
  setMessage,
  setExternalChatData,
  updateNotification,
  setChatSpinner,
  setMsgTone,
  setMsgTone2,
  setChatRefresh,
  setUserChatID,
  setloadmoreUser,
  setSelectedchanneldata,
  setUpdatechanneldata,
  endInteraction,
  setIncomingRequestRefresh,
  setShowCard,
  setLoadmoreSpinner,
  setShowingStatusClass,
  setShowingStatus,
} from "../../../redux/actions/actions";
import ChatInput from "./ChatInput.component";
import MessageComponent from "./Msg.component";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const mapStateToProps = (state) => {
  return {
    spaceContent: state.data.spaceContent,
    togglechat: state.data.togglechat,
    refreshtogglechat: state.data.refreshtogglechat,
    chat: state.data.chat,
    chatType: state.data.chatType,
    chatMessage: state.data.chatMessage,
    contactList: state.contactListData.contactList,
    notification: state.data.notification,
    contactList2: state.data.contactList2,
    chatid: state.data.chatid,
    confchatrefresh: state.data.confchatrefresh,
    agentList: state.data.agentList,
    internalchatrefresh: state.data.internalchatrefresh,
    internalchatnotify: state.data.internalchatnotify,
    chatdataforinternal: state.data.chatdataforinternal,
    conferenceNotification: state.data.conferenceNotification,
    conferenceNotificationVal: state.data.conferenceNotificationVal,
    availAgent: state.data.availAgent,
    loadmore: state.data.loadmore,
    addTopicInput: state.data.addTopicInput,
    addTopicToggle: state.data.addTopicToggle,
    message: state.data.message,
    externalChatData: state.data.externalChatData,
    loadmoretoggle: state.data.loadmoretoggle,
    chatspinner: state.data.chatspinner,
    userChatID: state.data.userChatID,
    selectedchanneldata: state.data.selectedchanneldata,
    updatechanneldata: state.data.updatechanneldata,
    loadmoreSpinner: state.data.loadmoreSpinner,
  };
};

const Message = (props) => {
  const { chat, chatid, userChatID } = props;

  let tenantId = localStorage.getItem("TenantId");
  const contentRef = useRef();
  const { spaceContent } = props;
  const [currentUserName, setCurrentUserName] = useState("");
  const [currentUserid, setCurrentUserid] = useState("");
  const [chatEmail, setChatEmail] = useState("");
  const [message, setMessage] = useState([]);
  const [loadmoredata, setLoadmoredata] = useState([]);
  const [session_id, setsession_id] = useState("");
  const [sender_id, setsender_id] = useState("");
  const [reciver_id, setreciver_id] = useState("");
  const [arrivalMessage, setArrivalMessage] = useState(null);
  const [lastmessage, setLastmessage] = useState([]);
  const [CustomerTyping, setCustomerTyping] = useState(false);
  // const [loadmoreSpinner, setLoadmoreSpinner] = useState(false);
  const isOnline = InternetError();
  const socket = useRef();

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const handleTyping = async () => {
    const data = await JSON.parse(localStorage.getItem("tokenAgent"));
    if (chat.chat_type == "internal") {
      let sender_id = chat.senderDetails[0]._id;
      let current_agent_id = data.id;
      if (sender_id == current_agent_id) {
        socket.current.emit("typing-send-msg", {
          to: chat.id,
          from: data.id,
          senderName: data.username,
          chatType: "outbound",
          chatdetails: chat,
        });
      } else {
        socket.current.emit("typing-send-msg", {
          to: chat.agent,
          from: data.id,
          senderName: data.username,
          chatType: "inbound",
          chatdetails: chat,
        });
      }
    } else {
      socket.current.emit("typing-send-msg", {
        to: chat.id,
        from: data.id,
        senderName: data.username,
        chatType: "outbound",
        chatdetails: chat,
      });
    }
  };

  const handleSendMsg = async (msg, msg_type, fileNameForDoc) => {
    console.log("handleSendMsg", msg);
    try {
      if (chat.chat_type == "internal") {
        var contactlist1 = props.agentList;
        var newcontactlist1 = [];
        var i = 0;
        var find = 0;

        contactlist1.map((client1, index) => {
          if (client1.id == chat.id) {
            find = i;
            client1.lastmessage = msg;
            client1.lastmessagetime = moment().format("h:mm A");
            client1.currentChat = client1.id == msg.from ? true : false;
            client1.unreadcount = 0;
          }
          newcontactlist1.push(client1);
          i++;
        });

        let newagent = insertAndShift(newcontactlist1, find, 0);

        props.setAgentList(newagent);
      } else {
        var contactlist = props.contactList;
        var newcontactlist = [];
        var i = 0;
        var find = 0;
        contactlist.map((client, index) => {
          if (client.id == chat.id) {
            find = i;
            client.lastmessage = msg;
            client.lastmessagetime = moment().format("h:mm A");
            client.lastmessageUpdatedat = moment();
            client.currentChat = client.id == msg.from ? true : false;
            client.unreadcount = 0;
          }
          newcontactlist.push(client);
          i++;
        });
        let newexternalcontact = insertAndShift(newcontactlist, find, 0);
        props.setcontactlist(newexternalcontact);
      }

      const data = await JSON.parse(localStorage.getItem("tokenAgent"));
      if (chat.chat_type == "internal") {
        let sender_id = chat.senderDetails[0]._id;
        let current_agent_id = data.id;
        if (sender_id == current_agent_id) {
          await axios.post(
            BaseUrl + "/message/addMessage",
            {
              from: data.id,
              to: chat.id,
              message: msg,
              senderName: data.username,
              receiverName: chat.username,
              messageFrom: "fromAgent",
              userType: chat.chat_type,
              session: chat.chat_session_id,
              msg_sent_type: msg_type,
              chatdetails: chat,
              file_name: fileNameForDoc,
              captions: "",
            },
            {
              headers: {
                tenantId: tenantId,
              },
            }
          );

          socket.current.emit("send-msg", {
            to: chat.id,
            session_id: chat.chat_session_id,
            from: data.id,
            senderName: data.username,
            chatType: "outbound",
            msg,
            msgType: "web",
            userType: chat.chat_type,
            msg_sent_type: msg_type,
            chatdetails: chat,
            file_name: fileNameForDoc,
            captions: "",
          });

          socket.current.emit("last-msg-send", {
            to: chat.id,
            from: data.id,
            chatType: "outbound",
            msg,
            senderName: data.username,
            userType: chat.chat_type,
            chatdetails: chat,
            file_name: fileNameForDoc,
            captions: "",
          });
        } else {
          await axios.post(
            BaseUrl + "/message/addMessage",
            {
              from: chat.id,
              to: chat.agent,
              message: msg,
              senderName: data.username,
              receiverName: chat.username,
              messageFrom: "fromClient",
              userType: chat.chat_type,
              session: chat.chat_session_id,
              msg_sent_type: msg_type,
              chatdetails: chat,
              file_name: fileNameForDoc,
              captions: "",
            },
            {
              headers: {
                tenantId: tenantId,
              },
            }
          );

          socket.current.emit("send-msg", {
            to: chat.agent,
            session_id: chat.chat_session_id,
            from: chat.id,
            senderName: data.username,
            chatType: "inbound",
            msg,
            msgType: "web",
            userType: chat.chat_type,
            msg_sent_type: msg_type,
            chatdetails: chat,
            file_name: fileNameForDoc,
            captions: "",
          });

          socket.current.emit("last-msg-send", {
            to: chat.agent,
            from: chat.id,
            chatType: "inbound",
            msg,
            senderName: data.username,
            userType: chat.chat_type,
            chatdetails: chat,
          });
        }

        setCustomerTyping(false);
      } else {
        await axios
          .post(
            BaseUrl + "/message/addMessage",
            {
              from: data.id,
              to: chat.id,
              message: msg,
              senderName: data.username,
              receiverName: chat.username,
              messageFrom: "fromAgent",
              userType: chat.chat_type,
              session: chat.chat_session_id,
              msg_sent_type: msg_type,
              file_name: fileNameForDoc,
              chatdetails: chat,
              captions: "",
            },
            {
              headers: {
                tenantId: tenantId,
              },
            }
          )
          .then((res) => {})
          .catch((err) => {});

        socket.current.emit("send-msg", {
          to: chat.id,
          from: data.id,
          session_id: chat.chat_session_id,
          senderName: data.username,
          chatType: "outbound",
          msg,
          msgType: "web",
          userType: chat.chat_type,
          msg_sent_type: msg_type,
          chatdetails: chat,
          file_name: fileNameForDoc,
          captions: "",
          time: moment().format("MMM DD, YYYY h:mm A"),
        });

        socket.current.emit("last-msg-send", {
          to: chat.id,
          from: data.id,
          chatType: "outbound",
          msg,
          senderName: data.username,
          userType: chat.chat_type,
          chatdetails: chat,
        });
      }

      const msgs = [...message];
      msgs.push({
        fromSelf: true,
        message: msg,
        session_id: chat.chat_session_id,
        senderName: data.username,
        receiverName: chat.username,
        to: chat.id,
        sender: data.id,
        time: moment().format(),
        msg_sent_type: msg_type,
        file_name: fileNameForDoc,
        captions: "",
      });

      setMessage(msgs);
      if (chat.chat_type !== "internal") {
        props.setCobrowserdata("");
        props.setvideoCalldata("");
      }
    } catch (error) {
      //console.log("error",error)
      toast.error("Internet connection is lost!");
    }
  };

  useEffect(() => {
    if (props.cobrowserdata) {
      let msg = props.cobrowserdata;
      handleSendMsg(msg, "TEXT", "");
    }
    if (props.videoCalldata) {
      let msg = props.videoCalldata;
      handleSendMsg(msg, "TEXT", "");
    }
  }, [props.cobrowserdata, props.videoCalldata]);

  function insertAndShift(arr, from, to) {
    let cutOut = arr.splice(from, 1)[0];

    arr.splice(to, 0, cutOut);
    return arr;
  }

  const showLastMsgExternal = (msg) => {
    var contactlist = props.contactList;
    var newcontactlist = [];
    var newcontactlist1 = [];
    var contactList1 = [];
    var unread_count = 0;
    var i = 0;
    var find = 0;
    contactlist.map((client, index) => {
      if (client.id == msg.from) {
        find = i;
        if (client.unreadcount) {
          unread_count = client.unreadcount + 1;
        } else {
          unread_count = 1;
        }

        client.lastmessage = msg.msg;
        client.lastmessagetime = moment().format("h:mm A");
        client.lastmessageUpdatedat = moment();
        client.unreadcount = unread_count;
        client.currentChat = client.id == msg.from ? true : false;

        updateLastMes(client.id, msg, moment().format("h:mm A"), unread_count);

        newcontactlist1 = {
          username: msg.senderName,
          client_msg: msg.msg,
          msg_time: moment().format("lll"),
          from_id: msg.from,
        };
        contactList1.push(newcontactlist1);
      }

      if (
        (msg.conference && client.id == msg.conference_id) ||
        (msg.conference && client.id == msg.to)
      ) {
        if (client.unreadcount) {
          unread_count = client.unreadcount + 1;
        } else {
          unread_count = 1;
        }

        client.lastmessage = msg.msg;
        client.lastmessagetime = moment().format("h:mm A");
        client.unreadcount = unread_count;
        client.currentChat = client.id == msg.from ? true : false;

        updateLastMes(client.id, msg, moment().format("h:mm A"), unread_count);

        newcontactlist1 = {
          username: msg.senderName,
          client_msg: msg.msg,
          msg_time: moment().format("lll"),
          from_id: msg.from,
        };
        contactList1.push(newcontactlist1);
      }

      newcontactlist.push(client);
      i++;
    });
    let newupdatedlist = insertAndShift(newcontactlist, find, 0);

    props.setcontactlist(newupdatedlist);
  };

  const showLastMsgInternal = (msg) => {
    let count = 1;
    props.agentList.forEach(function (item, i) {
      if (msg.chatType == "inbound") {
        if (item._id === msg.from) {
          props.agentList.splice(i, 1);
          props.agentList.unshift(item);
        }
      } else {
        if (item.agent === msg.from) {
          props.agentList.splice(i, 1);
          props.agentList.unshift(item);
        }
      }
    });

    count++;
    var contactlist = props.agentList;
    var newcontactlist = [];
    var unread_count = 0;

    props.agentList.map((client, index) => {
      if (msg.chatType == "inbound") {
        if (client.id == msg.from) {
          if (client.unreadcount) {
            unread_count = client.unreadcount + 1;
          } else {
            unread_count = 1;
          }

          client.lastmessage = msg.msg;
          client.lastmessagetime = moment().format("h:mm A");
          client.unreadcount = unread_count;
          client.currentChat = client.id == msg.from ? true : false;

          updateLastMes(
            client.id,
            msg,
            moment().format("h:mm A"),
            unread_count
          );
        }

        newcontactlist.push(client);
      } else {
        if (client.agent == msg.from) {
          if (client.unreadcount) {
            unread_count = client.unreadcount + 1;
          } else {
            unread_count = 1;
          }

          client.lastmessage = msg.msg;
          client.lastmessagetime = moment().format("h:mm A");
          client.unreadcount = unread_count;
          client.currentChat = client.id == msg.from ? true : false;

          updateLastMes(
            client.id,
            msg,
            moment().format("h:mm A"),
            unread_count
          );
        }

        newcontactlist.push(client);
      }
    });
    props.setAgentList(newcontactlist);
  };

  const updateLastMes = async (id, msg, date, count) => {
    let data_to_pass = {
      id: id,
      lastMsg: msg.msg,
      time: date,
      count: count,
    };
    const token = localStorage.getItem("access_token");

    const header = {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        tenantId: tenantId,
      },
    };
    await axios.post(
      BaseUrl + "/message/updateLastMessage",
      data_to_pass,
      header
    );
  };

  useEffect(() => {
    if (chat && arrivalMessage) {
      if (chat.chat_session_id == arrivalMessage.session_id) {
        arrivalMessage && setMessage((prev) => [...prev, arrivalMessage]);
      }
    }
  }, [arrivalMessage]);

  useEffect(() => {
    contentRef.current.scrollTop =
      contentRef.current.scrollHeight - contentRef.current.clientHeight;
  }, [message, CustomerTyping]);

  // *SOCKET CONNECTION///////////////
  const socketConnection = async () => {
    setCustomerTyping(false);

    const datas = await JSON.parse(localStorage.getItem("tokenAgent"));
    socket.current = io(SocketUrl + `/${localStorage.getItem("TenantId")}`);
    socket.current.on("disconnect", (msg) => {});
    socket.current.on("reconnect", () => {});
    socket.current.on("connect", function () {
      if (chat.chat_type == "internal") {
        let sender_id = chat.senderDetails[0]._id;

        let current_agent_id = datas.id;

        if (sender_id == current_agent_id) {
          socket.current.emit("add-user", datas.id);
        } else {
          socket.current.emit("add-user", chat.id);
        }
      } else {
        socket.current.emit("add-user", datas.id);
      }
    });
    socket.current.on("msg-receive", async (msg) => {
      if (chat.chat_type == "internal") {
        props.setMsgTone2(true);
        setsession_id("");
        setsender_id("");
        setreciver_id("");

        // socket.current.emit("add-user", msg.from);
        if (msg.chatType == "inbound") {
          var i = 0;
          let setActive = props.agentList.filter((lis) => {
            i = i + 1;
            return lis._id == msg.from;
          });

          if (chat.id == msg.from) {
            props.setinternalchatnotify(true);
            setCustomerTyping(false);
            setArrivalMessage({
              fromSelf: false,
              session_id: msg.session_id,
              message: msg.msg,
              senderName: msg.senderName,
              sender: msg.to,
              receiver: msg.from,
              time: moment().format(),
              msg_sent_type: msg.msg_sent_type,
              file_name: msg.file_name,
              captions: msg.captions,
            });
          }
        } else {
          let setActive = props.agentList.filter((lis) => {
            return lis.agent == msg.from;
          });

          if (msg.from == chat.agent) {
            props.setinternalchatnotify(true);
            setCustomerTyping(false);
            setArrivalMessage({
              fromSelf: false,
              session_id: msg.session_id,
              message: msg.msg,
              senderName: msg.senderName,
              sender: msg.to,
              receiver: msg.from,
              time: moment().format(),
              msg_sent_type: msg.msg_sent_type,
              file_name: msg.file_name,
              captions: msg.captions,
            });
          }
        }
      } else {
        var contactlist = props.contactList;
        const existingUser = await contactlist.find((user) => {
          return user.chat_session_id == msg.session_id;
        });
        if (existingUser) {
          props.setMsgTone2(true);
          setLastmessage(msg);

          if (chat.id == msg.from) {
            setArrivalMessage({
              fromSelf: false,
              message: msg.msg,
              session_id: msg.session_id,
              senderName: msg.senderName,
              sender: msg.from,
              receiver: msg.to,
              time: moment().format(),
              msg_sent_type: msg.msg_sent_type,
              file_name: msg.file_name,
              captions: msg.captions,
            });
          }

          if (
            msg.conference &&
            chat.id == msg.to &&
            msg.from !== datas.agent_id
          ) {
            setCustomerTyping(false);
            setArrivalMessage({
              fromSelf: true,
              message: msg.msg,
              session_id: msg.session_id,
              senderName: msg.senderName,
              sender: msg.from,
              receiver: msg.to,
              msg_sent_type: msg.msg_sent_type,
              file_name: msg.file_name,
              captions: msg.captions,
            });
          }
        } else {
          return;
        }
      }
      setCustomerTyping(false);
    });
    socket.current.on("typing-msg-receive", async (msg) => {
      if (msg.chatdetails.chat_type == "internal") {
        setsession_id(msg.chatdetails.chat_session_id);
        setsender_id(msg.chatdetails.senderDetails[0]._id);
        setreciver_id(msg.chatdetails.senderDetails[0]._id);
        setCustomerTyping(true);
      } else {
        var contactlist = props.contactList;
        const existingUser = await contactlist.find((user) => {
          return user.id == msg.from;
        });

        if (existingUser) {
          if (chat.id == msg.from) {
            setCustomerTyping(true);
          }
        } else {
          return;
        }
      }
    });
  
    socket.current.on("customer-end-chat", async (data) => {
      var contactlist = props.contactList;

      const existingUser = await contactlist.find((user) => {
        return user.chat_session_id == data.session_id;
      });

      if (existingUser) {
        var contactlist = props.contactList;
        var newcontactlist = [];
        contactlist.map((client, index) => {
          if (client.chat_session_id == data.chat_session_id) {
            client.is_customer_disconnected = true;
            props.setShowCard(false);
          }
          newcontactlist.push(client);
        });
        props.setcontactlist(newcontactlist);
        props.setChatRefresh(true);
      } else {
        return;
      }
    });
    socket.current.on("recv-internal", async (newUser) => {
      let lastElement = newUser.pop();
      var oldReqAgent = props.agentList;
      props.setinternalchatrefresh(true);

      oldReqAgent = oldReqAgent.filter((item) => {
        return item.user_id != lastElement.user_id;
      });
      var listrequest = [];
      props.setAgentList(oldReqAgent);
      if (lastElement) {
        if (datas.id == lastElement.reciverDetails[0]._id) {
          listrequest = lastElement;
          oldReqAgent.push(listrequest);
          props.setchatdata(listrequest);
        }
      }
    });

    socket.current.on("email-receive", (data) => {
      props.setSelectedchanneldata(data.Data);
      props.setUpdatechanneldata(data.EmailBody);
    });
    socket.current.on("last-msg-receive", async (msg) => {
      if (msg.userType === "internal") {
        var newNotification = {
          id: msg.from,
          username: msg.senderName,
          client_msg: msg.msg,
          from_id: msg.from,
          chatType: msg.chatType,
        };
        props.updateNotification(newNotification);
        showLastMsgInternal(msg);
      } else {
        var contactlist = props.contactList;
        const existingUser = await contactlist.find((user) => {
          return user.id == msg.from;
        });

        if (existingUser) {
          var newNotification = {
            id: msg.from,
            username: msg.senderName,
            client_msg: msg.msg,
            from_id: msg.from,
            chatType: msg.chatType,
          };

          props.updateNotification(newNotification);
          showLastMsgExternal(msg);
        } else {
          return;
        }
      }
    });
  };

  useEffect(() => {
    socketConnection();
  }, [userChatID, props.contactList]);

  useEffect(() => {
    if (userChatID) {
      async function getData() {
        const datas = await JSON.parse(localStorage.getItem("tokenAgent"));
        setCurrentUserid(datas.id);
        setCurrentUserName(datas.username);
        try {
          const response = await axios.post(
            BaseUrl + "/message/getCurrentChatMessage",
            {
              sessionId: userChatID,
            },
            {
              headers: {
                tenantId: tenantId,
              },
            }
          );

          if (chat.chat_type == "internal") {
            let sender_id = chat.senderDetails[0]._id;
            let current_agent_id = datas.id;
            if (sender_id != current_agent_id) {
              if (response.data.data) {
                setTimeout(() => {
                  props.setChatSpinner(false);
                  setMessage(response.data.data);
                }, 1000);
              } else {
                setTimeout(() => {
                  props.setChatSpinner(false);
                  setMessage([]);
                }, 1000);
              }
            } else {
              if (response.data.data) {
                setTimeout(() => {
                  props.setChatSpinner(false);
                  setMessage(response.data.data);
                }, 1000);
              } else {
                setTimeout(() => {
                  props.setChatSpinner(false);

                  setMessage([]);
                }, 1000);
              }
            }
          } else {
            if (response.data.data) {
              setTimeout(() => {
                props.setChatSpinner(false);

                setMessage(response.data.data);
              }, 1000);
            } else {
              setTimeout(() => {
                props.setChatSpinner(false);

                setMessage([]);
              }, 1000);
            }
          }
        } catch (error) {
          setTimeout(() => {
            props.setChatSpinner(false);
            setMessage([]);
          }, 1000);
        }
      }
      getData();
      props.setUserChatID("");
    }
    setCustomerTyping(false);
  }, [userChatID]);

  const loadmore = async () => {
    props.setLoadmoreSpinner(true);
    if (chat.chat_type == "external") {
      var payload = {
        messager_id: chat.unique_id.id,
        session_id: chat.chat_session_id,
        agent: chat.agent,
        offset: 0,
        limit: 1000,
      };
      var url = "/message/listmessagepagination";
    } else if (chat.chat_type == "internal") {
      var payload = {
        sender_id: chat.senderDetails[0]._id,
        receiver_id: chat.reciverDetails[0]._id,
        session_id: chat.chat_session_id,
        offset: 0,
        limit: 1000,
      };
      var url = "/message/listInternalMessage";
    }

    const token = localStorage.getItem("access_token");

    const header = {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        tenantId: tenantId,
      },
    };

    const { data } = await axios.post(BaseUrl + url, payload, header);

    if (data.status == true) {
      setLoadmoredata(data.data);
      props.setloadmore(true);
      props.setrefreshtogglechat(false);
      setTimeout(() => {
        props.setLoadmoreSpinner(false);
      }, 1000);
    } else {
      setLoadmoredata([]);
      props.setloadmore(true);
      props.setrefreshtogglechat(false);
      setTimeout(() => {
        props.setLoadmoreSpinner(false);
      }, 1000);
    }
  };

  return (
    <>
      <div className="chat-boxs p-2">
        <div className="chat-box-body">
          <div className="chat-logs">
            <div className="messagess" id="chat" ref={contentRef}>
              {props.chatspinner && (
                <>
                  <div
                    className="d-flex justify-content-center position-absolute h-100"
                    style={{
                      zIndex: 999,
                      width: "290px",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        height: "60px",
                        top: "25%",
                        right: props.userlistshow ? "-80px" : "-250px",
                      }}
                    >
                      <CSpinner
                        style={{
                          position: "absolute",
                          top: "0",
                          left: "15px",
                          color: "#0b3363",
                        }}
                      />
                      <span
                        style={{
                          position: "absolute",
                          bottom: "0",
                          fontFamily: "monospace",
                          color: "#0b3363",
                        }}
                      >
                        LOADING...
                      </span>
                    </div>
                  </div>
                </>
              )}

              {!props.chatspinner && (
                <>
                  {" "}
                  {chat.chat_type == "external" &&
                  !props.loadmoretoggle &&
                  props.contactList.length > 0 ? (
                    <div>
                      <div
                        className="agentSideLoad "
                        onClick={() => {
                          loadmore();
                        }}
                        style={{
                          marginLeft: props.userlistshow ? "-3rem" : "8rem",
                        }}
                      >
                        <span>
                          {props.loadmoreSpinner ? (
                            <CSpinner
                              style={{
                                position: "absolute",
                                top: "0",
                                left: "15px",
                                color: "#0b3363",
                              }}
                            />
                          ) : (
                            "load more"
                          )}
                        </span>
                      </div>
                    </div>
                  ) : chat.chat_type == "internal" && !props.loadmoretoggle ? (
                    <div
                      className="agentSideLoad "
                      onClick={() => {
                        loadmore();
                      }}
                      style={{
                        marginLeft: props.loadmoreUser ? "-3rem" : "8rem",
                      }}
                    >
                      <span>
                        {props.loadmoreSpinner ? (
                          <CSpinner
                            style={{
                              position: "absolute",
                              top: "0",
                              left: "15px",
                              color: "#0b3363",
                            }}
                          />
                        ) : (
                          "load more"
                        )}
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                  {props.loadmoretoggle &&
                    loadmoredata.map((item, index) => (
                      <MessageComponent key={index} message={item} />
                    ))}
                  {!isOnline ? (
                    message.map((item, index) => (
                      <MessageComponent key={index} message={item} />
                    ))
                  ) : (
                    <div>
                      {message.map((item, index) => (
                        <MessageComponent key={index} message={item} />
                      ))}
                    </div>
                  )}
                  {chat &&
                  session_id == chat.chat_session_id &&
                  chat.chat_type == "internal" &&
                  sender_id == chat.senderDetails[0]._id &&
                  sender_id != "" &&
                  CustomerTyping ? (
                    <div className="chat-l">
                      <div className="bot-chat-main d-flex justify-content-start">
                        <div className="d-flex justify-content-start flex-column align-items-start">
                          <div className="bot-chats text-break">
                            <div className="typing-main">
                              <div className="typing typing-1"></div>
                              <div className="typing typing-2"></div>
                              <div className="typing typing-3"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  {chat && chat.chat_type != "internal" && CustomerTyping ? (
                    <div className="chat-l">
                      <div className="bot-chat-main d-flex justify-content-start">
                        <div className="d-flex justify-content-start flex-column align-items-start">
                          <div className="bot-chats text-break">
                            <div className="typing-main">
                              <div className="typing typing-1"></div>
                              <div className="typing typing-2"></div>
                              <div className="typing typing-3"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </>
              )}
            </div>

            {props.value == 1 ? (
              <ChatInput
                handleTyping={handleTyping}
                handleSendMsg={handleSendMsg}
                data={props}
                disabled={props.externalChatData.is_customer_disconnected}
              />
            ) : props.externalChatData.is_customer_disconnected == true ||
              props.hideInput == true ? (
              <></>
            ) : (
              <ChatInput
                handleTyping={handleTyping}
                handleSendMsg={handleSendMsg}
                data={props}
                disabled={props.externalChatData.is_customer_disconnected}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, {
  setcontactlist,
  setcontactlist1,
  setcontactlist2,
  setconfchatrefresh,
  setAgentList,
  setinternalchatrefresh,
  setchatdata,
  setchatid,
  setrefreshtogglechat,
  setselectedmobile,
  setselectedemail,
  setselectedusername,
  setchattype,
  setinternalchatnotify,
  setchatdataforinternal,
  setConferenceNotification,
  setavailagent,
  setloadmore,
  setMessage,
  setExternalChatData,
  updateNotification,
  setChatSpinner,
  setMsgTone,
  setMsgTone2,
  setChatRefresh,
  setUserChatID,
  setloadmoreUser,
  setSelectedchanneldata,
  setUpdatechanneldata,
  endInteraction,
  setIncomingRequestRefresh,
  setShowCard,
  setLoadmoreSpinner,
  setShowingStatusClass,
  setShowingStatus,
})(Message);
